const DominicaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111306)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.9126 39.6162C31.8191 38.0478 38.0473 31.8195 39.6157 23.9131H23.9126V39.6162Z"
        fill="#496E2D"
      />
      <path
        d="M0.383301 23.9131C1.95166 31.8195 8.17994 38.0478 16.0864 39.6162V23.9131H0.383301Z"
        fill="#496E2D"
      />
      <path
        d="M39.6157 16.0869C38.0473 8.18051 31.8191 1.95223 23.9126 0.383789V16.0869H39.6157Z"
        fill="#496E2D"
      />
      <path
        d="M16.0864 0.383789C8.17994 1.95223 1.95166 8.18051 0.383301 16.0869H16.0864V0.383789Z"
        fill="#496E2D"
      />
      <path
        d="M18.6951 23.9131H16.0864V39.6162C16.9378 39.785 17.8086 39.8994 18.6951 39.9565V23.9131Z"
        fill="#FFDA44"
      />
      <path
        d="M18.6951 16.0864V0.0429688C17.8086 0.1 16.9377 0.214453 16.0864 0.383281V16.0864H18.6951Z"
        fill="#FFDA44"
      />
      <path
        d="M21.3046 0.0435156C20.8731 0.015625 20.4385 0 20.0002 0C19.5618 0 19.1272 0.015625 18.6958 0.0435156V16.087H21.3045V0.0435156H21.3046Z"
        fill="black"
      />
      <path
        d="M18.6958 39.9565C19.1272 39.9844 19.5618 40 20.0002 40C20.4385 40 20.8731 39.9844 21.3046 39.9565V23.9131H18.6959V39.9565H18.6958Z"
        fill="black"
      />
      <path
        d="M16.0869 18.6956V16.0869H0.38377C0.214863 16.9383 0.100488 17.8091 0.043457 18.6956H16.0869Z"
        fill="#FFDA44"
      />
      <path
        d="M23.9136 18.6956H39.9571C39.9001 17.8091 39.7856 16.9383 39.6168 16.0869H23.9137V18.6956H23.9136Z"
        fill="#FFDA44"
      />
      <path
        d="M23.9136 21.3041H39.9571C39.9849 20.8727 40.0005 20.438 40.0005 19.9997C40.0005 19.5613 39.9849 19.1266 39.957 18.6953H23.9136V21.3041Z"
        fill="black"
      />
      <path
        d="M0.0435156 18.6953C0.0157031 19.1266 0 19.5613 0 19.9997C0 20.438 0.0157031 20.8727 0.0435156 21.3041H16.087V18.6954H0.0435156V18.6953Z"
        fill="black"
      />
      <path
        d="M20.0003 29.565C25.283 29.565 29.5655 25.2825 29.5655 19.9998C29.5655 14.7171 25.283 10.4346 20.0003 10.4346C14.7176 10.4346 10.4351 14.7171 10.4351 19.9998C10.4351 25.2825 14.7176 29.565 20.0003 29.565Z"
        fill="#D80027"
      />
      <path
        d="M22.1784 21.0671C21.4669 19.6442 20.5421 18.202 20.5421 18.202C20.5421 18.202 20.5651 17.5454 20.5651 17.1541C20.5651 16.5647 20.0873 16.0869 19.4979 16.0869C18.9396 16.0869 18.482 16.5159 18.4354 17.0621C17.9963 17.0907 17.6489 17.455 17.6489 17.9012C17.6489 18.2257 17.8328 18.5068 18.1018 18.6474C18.2356 18.3346 18.4974 18.0904 18.8213 17.979C18.8742 18.0222 18.9309 18.0608 18.9914 18.0936L19.1281 18.159C19.1281 18.159 18.6212 19.588 18.6212 20.3557C18.6212 22.5138 20.0442 23.1793 20.0442 23.1793V23.2016L19.3327 23.913H20.7556V22.49L21.4671 23.2015C21.4733 23.1882 22.8147 22.3398 22.1784 21.0671Z"
        fill="#496E2D"
      />
      <path
        d="M19.9998 12.1729L20.3236 13.1693H21.3712L20.5237 13.7851L20.8475 14.7815L19.9998 14.1657L19.1522 14.7815L19.476 13.7851L18.6284 13.1693H19.6761L19.9998 12.1729Z"
        fill="#496E2D"
      />
      <path
        d="M15.3994 13.668L16.2469 14.2839L17.0946 13.668L16.7708 14.6645L17.6185 15.2802L16.5707 15.2803L16.247 16.2767L15.9231 15.2803L14.8755 15.2802L15.7231 14.6644L15.3994 13.668Z"
        fill="#496E2D"
      />
      <path
        d="M12.5566 17.5823H13.6042L13.928 16.5859L14.2518 17.5823L15.2995 17.5823L14.452 18.1982L14.7758 19.1946L13.928 18.5787L13.0805 19.1945L13.4041 18.1981L12.5566 17.5823Z"
        fill="#496E2D"
      />
      <path
        d="M12.5566 22.4179L13.4041 21.8021L13.0804 20.8057L13.928 21.4215L14.7757 20.8057L14.452 21.8021L15.2996 22.4179L14.2518 22.418L13.928 23.4143L13.6042 22.4179H12.5566Z"
        fill="#496E2D"
      />
      <path
        d="M15.3995 26.3322L15.7231 25.336L14.8755 24.7201H15.9232L16.2471 23.7236L16.5708 24.72H17.6185L16.7709 25.336L17.0946 26.3323L16.247 25.7164L15.3995 26.3322Z"
        fill="#496E2D"
      />
      <path
        d="M19.9998 27.8255L19.6761 26.8292H18.6284L19.476 26.2133L19.1522 25.2169L19.9998 25.8326L20.8474 25.2168L20.5237 26.2133L21.3712 26.8291L20.3236 26.8292L19.9998 27.8255Z"
        fill="#496E2D"
      />
      <path
        d="M24.5999 26.3322L23.7524 25.7164L22.9048 26.3324L23.2285 25.336L22.3809 24.7201L23.4286 24.72L23.7523 23.7236L24.0762 24.7201H25.1238L24.2762 25.336L24.5999 26.3322Z"
        fill="#496E2D"
      />
      <path
        d="M27.4427 22.4178H26.3951L26.0713 23.4143L25.7475 22.4179H24.6997L25.5474 21.802L25.2235 20.8057L26.0713 21.4214L26.9188 20.8057L26.5952 21.8021L27.4427 22.4178Z"
        fill="#496E2D"
      />
      <path
        d="M27.4427 17.5823L26.5952 18.198L26.9188 19.1945L26.0713 18.5787L25.2236 19.1946L25.5474 18.1981L24.6997 17.5823L25.7475 17.5822L26.0712 16.5859L26.3951 17.5823H27.4427Z"
        fill="#496E2D"
      />
      <path
        d="M24.5999 13.668L24.2762 14.6643L25.1238 15.2802H24.0762L23.7524 16.2766L23.4286 15.2802L22.3809 15.2803L23.2285 14.6643L22.9048 13.668L23.7524 14.2838L24.5999 13.668Z"
        fill="#496E2D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111306">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default DominicaSvg;
